module.exports = __webpack_public_path__ + "img/curator.92cefbcf.webp";